export const AuthEndpoints = {
    login: () => '/online-giving/access/email/signin',
    appMigrate: () => '/online-giving/access/app-migrate',
    getLoginTypes: (email: string, token?: string) =>
        `/access/email/login-types?email=${encodeURIComponent(email)}${
            token ? `&recaptcha=${token}` : ''
        }`,
    activateDonorProfile: () => '/online-giving/access/email/activate',
    resendActivateEmail: () => '/online-giving/access/email/verify',
    activateDonorEmail: () => '/online-giving/access/email/change',
    getTokenWithRefresh: () => '/online-giving/access/refresh',
    facebookLoginRequest: () => '/online-giving/access/facebook',
    userSetPassword: () => '/access/password/reset/update',
    userSignup: () => '/online-giving/access/email/join',
    passwordReset: () => '/access/password/reset',
};
